import { Component, OnInit,Input, Output } from '@angular/core';
import { ModelList } from '../../include/modellist'
import { UntypedFormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Filter,FilterMode,Alarm, Condition } from '../../include/structures'
import { AlarmsService } from '../../lib/alarms.service';



@Component({
  selector: 'app-alarms',
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.sass']
})
export class AlarmsComponent extends ModelList<Alarm> implements OnInit {

  
 
  filter_type:Filter=new Filter();
  selectedAlarm:Alarm={} as Alarm;
  


  constructor(
    private fb1: UntypedFormBuilder,
    private alarmsService: AlarmsService,
    
  ) {
    super(alarmsService,fb1);
   }

   ngOnInit(): void {
    this.title='Avvisi';
    super.ngOnInit.apply(this, arguments); 
    
    this.filter_type.mode=FilterMode.normal;
    this.filter_type.fields=[];
    this.filter_type.fields.push("a.table");
    this.filter_type.value="";
    this.filter.push(this.filter_type);

    this.ordering.field="a.id";

    this.getItems();
 
    
  }


  setRule(record:Alarm){
    
    this.selectedAlarm=Object.assign({}, record);;

    this.selectedAlarm.conditionsArray=[];
    if(this.selectedAlarm.conditions!="")
      this.selectedAlarm.conditionsArray=JSON.parse(this.selectedAlarm.conditions);

  }

  confirmRule():void{
    this.selectedAlarm.conditions=JSON.stringify(this.selectedAlarm.conditionsArray);
    this.alarmsService.save(this.selectedAlarm,(id)=>{
      this.getItems();
    });
  }

  addAlarm(){
    let r:Alarm={} as Alarm;
    r.status=1;

    
    if(this.filter_type.value!="")
      r.table=this.filter_type.value;
    this.selectedAlarm=r;
  }

  addCondition():void{
    let c:Condition={} as Condition;
    if(this.selectedAlarm.conditionsArray==undefined)
      this.selectedAlarm.conditionsArray=[];

    this.selectedAlarm.conditionsArray.push(c);
  }

  removeCondition(c:Condition):void{
    for(let i=0;i<this.selectedAlarm.conditionsArray.length;i++)
      if(this.selectedAlarm.conditionsArray[i]==c)
        this.selectedAlarm.conditionsArray.splice(i,1);
  }
    
  confirm_delete(id){
    confirm("Eliminare l'elemento?")?this.delete(id):false;
  }


}
